import { render, staticRenderFns } from "./AsideNav.vue?vue&type=template&id=725d42c0"
import script from "./AsideNav.vue?vue&type=script&lang=js"
export * from "./AsideNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports